import React, { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Soft phase strip — orientational, not progressive.
 *
 * Sits as a thin, quiet line above the AdvisorCoach. Each phase is a tiny
 * label with a thin underline. The active phase has a teal underline. No
 * numbering. No "next" arrow. No completion %. No wizard chrome.
 *
 * Tone: "where we are in the conversation", not "complete the steps".
 */
export default function ConversationPhaseStrip({ phase, reason, className = "" }) {
  const [phases, setPhases] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/intake/phases`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
    })
      .then((r) => r.json())
      .then((d) => { if (!cancelled) setPhases(d?.phases || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (phases.length === 0) return null;

  return (
    <div
      className={`select-none ${className}`}
      data-testid="conversation-phase-strip"
      aria-label="Conversational phase"
    >
      <div className="flex items-baseline gap-x-6 gap-y-2 flex-wrap text-[12px] uppercase tracking-[0.18em] font-medium">
        {phases.map((p) => {
          const active = p.id === phase;
          return (
            <span
              key={p.id}
              className={`relative pb-1 transition-colors ${
                active
                  ? "text-slate-900"
                  : "text-slate-400"
              }`}
              data-testid={`phase-chip-${p.id}`}
              title={p.intent}
            >
              {p.label}
              <span
                className={`absolute left-0 right-0 -bottom-px h-[2px] rounded-full transition-all ${
                  active ? "bg-teal-600" : "bg-transparent"
                }`}
              />
            </span>
          );
        })}
      </div>
      {reason && (
        <p className="text-[12.5px] text-slate-500 italic mt-2 leading-snug" data-testid="phase-reason">
          {reason}
        </p>
      )}
    </div>
  );
}
